export const SET_FILTERS = 'SET_FILTERS'